import { render } from "./SquareUserItem.vue?vue&type=template&id=c4519086&scoped=true"
import script from "./SquareUserItem.vue?vue&type=script&lang=js"
export * from "./SquareUserItem.vue?vue&type=script&lang=js"

import "./SquareUserItem.vue?vue&type=style&index=0&id=c4519086&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4519086"]])

export default __exports__